import React, { useCallback, useState, memo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import get from 'lodash.get';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';
import * as ReturnActions from '../../../store/returns/returns.actions';
import { emptyArray } from 'ui-components/default-props/empty';
import { SingleReturn } from './single-return';
import { MultipleReturns } from './multiple-returns';

const messages = defineMessages({
  emailTo: {
    description: 'emailReturnLabel.emailTo',
    defaultMessage: 'Email to',
    id: 'vM0h/Z',
  },
});

const EmailReturnLabelModalComponent = ({ modalFrameworkMethods, returns = emptyArray }) => {
  const emails = returns.map((r) => ({
    fulfillmentId: get(r, 'fulfillmentId'),
    emailTo: get(r, 'returnEmailInformation.emails', ''),
    rmaNumber: get(r, 'rmaNumber', ''),
    name: get(r, 'returnFromName'),
  }));

  const { closeModal } = modalFrameworkMethods;
  const dispatch = useDispatch();
  const [fulfillmentEmails, setFulfillmentEmails] = useState(emails);

  const updateEmailTo = useCallback(
    (index, value) => {
      const newFulfillmentEmails = [...fulfillmentEmails];
      newFulfillmentEmails[index].emailTo = value;
      setFulfillmentEmails(newFulfillmentEmails);
    },
    [setFulfillmentEmails, fulfillmentEmails],
  );

  const sendReturnLabelsAndCloseModal = useCallback(() => {
    dispatch(ReturnActions.sendReturnLabelToEmail(fulfillmentEmails));
    closeModal();
  }, [closeModal, fulfillmentEmails, dispatch]);

  if (fulfillmentEmails.length === 1) {
    const { emailTo } = fulfillmentEmails[0];
    return (
      <SingleReturn
        closeModal={closeModal}
        emailTo={emailTo}
        message={messages.emailTo}
        sendReturnLabels={sendReturnLabelsAndCloseModal}
        updateEmailTo={updateEmailTo}
      />
    );
  }
  return (
    <MultipleReturns
      closeModal={closeModal}
      fulfillmentEmails={fulfillmentEmails}
      sendReturnLabels={sendReturnLabelsAndCloseModal}
      updateEmailTo={updateEmailTo}
    />
  );
};

EmailReturnLabelModalComponent.propTypes = {
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
  returns: PropTypes.array,
};

export const EmailReturnLabelModal = memo(EmailReturnLabelModalComponent);
